import { useNavigate } from "react-router-dom";

export default function Footer() {
  const navigate = useNavigate();

  return (
    <footer className="bg-background-100 py-14 md:py-20 px-4 md:px-8 lg:px-12">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 lg:gap-8">
          <div>
            <img
              src="https://public.readdy.ai/ai/img_res/b1fd4538-34ee-4db1-8102-41d840bea221.png"
              alt="Castillo Painting Inc."
              className="h-14 w-auto mb-5"
            />
            <p className="text-foreground-600 text-sm leading-relaxed mb-6 max-w-xs">
              Professional painting services for residential and commercial
              properties across Southern California. Licensed, Bonded & Insured.
            </p>
            <div className="space-y-2 text-sm">
              <p className="text-foreground-700">
                <span className="font-medium">Phone:</span>{" "}
                <a
                  href="tel:9514792556"
                  className="text-primary-600 hover:text-primary-700 transition-colors"
                >
                  (951) 479-2556
                </a>
              </p>
              <p className="text-foreground-700">
                <span className="font-medium">License:</span> #1150059
              </p>
            </div>

            <div className="flex items-center gap-3 mt-5">
              <a
                href="https://instagram.com/castillo_painting_inc"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-200/70 hover:bg-primary-100 text-foreground-600 hover:text-primary-600 transition-all cursor-pointer"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a
                href="https://www.tiktok.com/@jcjunkhauling?_r=1&_t=ZP-98CuOyratu3"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-200/70 hover:bg-primary-100 text-foreground-600 hover:text-primary-600 transition-all cursor-pointer"
                aria-label="TikTok"
              >
                <i className="ri-tiktok-line text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-medium text-foreground-950 mb-4">
              Services
            </h4>
            <ul className="space-y-2.5">
              {[
                "Interior Painting",
                "Exterior Painting",
                "Residential",
                "Commercial",
                "Wood & Stucco Repairs",
                "Pressure Washing",
                "Drywall Repair",
                "Texturing",
              ].map((s) => (
                <li key={s}>
                  <a
                    href="/services"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/services");
                    }}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                  >
                    {s}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-medium text-foreground-950 mb-4">
              Service Areas
            </h4>
            <ul className="space-y-2.5">
              {[
                "Riverside County",
                "San Bernardino County",
                "Orange County",
                "San Diego County",
                "Los Angeles County",
              ].map((a) => (
                <li key={a}>
                  <span className="text-sm text-foreground-600">{a}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-background-300/60 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} Castillo Painting Inc. All rights
            reserved.
          </p>
          <p className="text-xs text-foreground-500">
            Licensed, Bonded & Insured | Corona, CA
          </p>
        </div>
      </div>
    </footer>
  );
}